<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-card-title class="toolbar"> Group Notices </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="6">
            <v-select
              :items="communication_groups"
              prepend-icon="mdi-account-child-circle"
              item-text="title"
              item-value="id"
              @change="getNotices(selected_group)"
              outlined
              hint="Select Group"
           persistent-hint
              dense
              v-model="selected_group"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <br />
    <div v-for="notice in searchByTitleOrDescription" :key="notice.id">
      <v-card dense>
        <v-chip class="ma-2" :color="notice.srno % 2 == 0 ? 'warning' : 'info'">
          {{ notice.issue_date }}
        </v-chip>
        <v-card-title class="title font-weight-regular">
          {{ notice.title }}
        </v-card-title>
        <v-card-text>
          <v-btn
            class="ma-2"
            small
            outlined
            color="indigo"
            v-if="!notice.visited"
            @click="viewMore(notice)"
            >View More</v-btn
          >
          <template v-if="notice.visited">
            Description:
          <span v-html="notice.description"></span>
          <br>

           <template v-if="notice.url"> 
                <a :href="notice.url" target="_blank" v-if="notice.url != '--'">
                    <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
                </a>
                  <span v-else style="opacity: 0.5;">{{ notice.url }}</span>
              </template> 
           <!-- <a v-if="notice.url != null" :href="notice.url" target="_blank"> <v-icon>mdi-attachment</v-icon></a> -->
          <br>
          <template v-if="notice.attachment" >
               Attachments
              <!-- {{notice.attachment_links}} -->
              <span v-if="notice.attachment">:
                        <span v-for="(item, i) in notice.attachment_links" :key="i">
                            <a class="p-2" :href="s3url+item.link" target="blank">
                                <v-tooltip top>
                                    <template v-slot:activator="{ attrs }">
                                     <v-btn icon v-bind="attrs"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                        <!--  <v-btn
                                        class="mx-2"
                                        small
                                        dark
                                        outlined
                                        color="success"
                                        v-bind="attrs"
                                        @click="downloadNoticeAttachment(s3url+item.link)"
                                        ><v-icon> mdi-download</v-icon>
                                        {{s3url+item.link}}
                                  </v-btn> -->


                                        <!-- <v-btn icon v-if="item != null" v-bind="attrs"> <v-icon color="black">mdi-eye</v-icon></v-btn> -->
                                    </template>
                                    <span> View Attachment File!!! </span>
                                </v-tooltip>
                            </a>
                        </span>
              </span>
              <!-- <v-btn
                class="mx-2"
                small
                dark
                outlined
                color="success"
                @click="downloadNoticeAttachment(notice.attachment_links)"
                >{{ notice.attachment }}<v-icon> mdi-download</v-icon>
              </v-btn>  -->
              </template>
          </template>

        </v-card-text>

        
      </v-card>
      <br />
    </div>
    <!-- {{ this.child_notice.length}} -->
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    children: [],
    selected_group: "",
    communication_groups: [],
    selected_children: "",
    child_info: null,
    child_notice: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    loader: true,
    search: "",
    s3url: "",
  }),

  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getNotices(item) {
      const formData = {
        group_id: item,
        type: "Notice",
      };
      axios
        .post("communicationGroup/getNoticess", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if ((res.data.status = "SUCCESS")) {
              if (res.data.child_info.length != 0) {
                this.child_info = res.data.child_info;
                this.childrenList();
              } else {
              }
            }
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    onLoad() {
      const formData = {
        type: "Notice",
      };
      axios
        .get("communicationGroup/getCalendar")
        .then((res) => {
          if (res.data.msg == "200") {
            this.communication_groups = res.data.communication_groups;
            return;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.loader = false;
          //alert("done")
        });
    },
    viewMore(notice) {
      const formData = {
        id: notice.notice_id,
        commn_to_grp_id: notice.commn_to_grp_id,
        type: "Notice",
      };
      axios
        .post("/communicationGroup/markViewedNotice", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "SUCCESS") {
              notice.visited = true;
            } else {
              //alert(res.data.status_reason);
            }
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.loader = false;
          //alert("done")
        });
    },
    downloadNoticeAttachment(dlinkpath) {
      //let s3url = "https://eduplusschool.s3.ap-south-1.amazonaws.com/";

      //console.log("dlinkpath>>"+dlinkpath)
      for (let j = 0; j < dlinkpath.length; j++) {
        var link = document.createElement("a");
        let path = dlinkpath[j].path;
        link.download = dlinkpath[j].name; // 16yqok7xkop.xls
        //console.log("url>>"+s3url+path+link.download)
        link.href = this.s3url + path + link.download;
        link.target = "_blank";
        link.click();
      }
    },
    childrenList() {
      //console.log(" children Len>>"+this.child_info.length)
      for (let i = 0; i < this.child_info.length; i++) {
        //console.log(" children>>"+this.child_info[i].grno)
        this.children.push(
          this.child_info[i].grno + ":" + this.child_info[i].name
        );
        this.selected_children =
          this.child_info[i].grno + ":" + this.child_info[i].name;
        this.displayNotice();
      }
      //console.log(" children>>"+this.children)
    },
    displayNotice() {
      //alert('11'+this.selected_children)
      //let grno = this.selected_children;
      //let res = grno.split(":");
      // return res[1];
      for (let i = 0; i < this.child_info.length; i++) {
        //if (res[0] == this.child_info[i])
        this.child_notice = this.child_info[i];
      }
      if (this.child_notice.notices.length == 0) {
        this.showSnackbar("#b71c1c", "No Events Available For This Group..!!!");
        return;
      }
    },
  },
  mounted() {
    this.onLoad();
    this.s3url = localStorage.getItem("awspath");
  },
  computed: {
    searchByTitleOrDescription() {
      /*function compare(a, b) {
        if (a.title < b.title || a.description < b.description) return -1;
        if (a.title > b.title || a.description < b.description) return 1;
        return 0;
      }
      if (!this.search) return this.child_notice.notices.sort(compare);*/
      if (this.child_notice) {
        return this.child_notice.notices.filter((tbdata) => {
          return (
            tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            tbdata.description
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
          );
        });
      }
    },
  }, // end of computed()
};
</script>
